import React from 'react'
import {
  Bullet,
  Bullets,
  Page,
  Screenshot,
  Section,
} from '../../../components/CommandControlComponents'

const ScreenLayouts = () => (
  <Page
    title="Control Room Screen Layouts"
    intro="The control room supports three layouts so a team can run from one laptop, a dual-screen command desk, or a large control-room wall."
  >
    <Section title="Compact view">
      <Bullets>
        <Bullet>Designed to show the whole operation on one screen.</Bullet>
        <Bullet>
          Dispatch List and Ongoing Incidents sit above Resources and the Map.
        </Bullet>
        <Bullet>
          Treatment Centres and Control Logs are available lower down the page.
        </Bullet>
        <Bullet>
          Useful for a single commander, small event, or laptop-based control
          point.
        </Bullet>
      </Bullets>
    </Section>

    <Section title="Screen 1">
      <Bullets>
        <Bullet>Designed for incident control and command logging.</Bullet>
        <Bullet>
          Shows Dispatch List and Ongoing Incidents using the same split as
          Compact view.
        </Bullet>
        <Bullet>Does not show the Resources card.</Bullet>
        <Bullet>
          Treatment Centres occupy the wider left section, with Control Logs to
          the right.
        </Bullet>
        <Bullet>
          Control Logs load 10 entries at first and scroll internally when more
          are loaded.
        </Bullet>
      </Bullets>
      <Screenshot
        url="command-control/CadScreen1.png"
        alt="
        Screen 1 showing Dispatch List, Ongoing Incidents, Treatment Centres, and Control Logs."
      ></Screenshot>
    </Section>

    <Section title="Screen 2">
      <Bullets>
        <Bullet>Designed for mapping and resource visibility.</Bullet>
        <Bullet>
          Shows the selected map view full width: Map, Event, Overlay, or GPX.
        </Bullet>
        <Bullet>
          The resource list appears beside the map so operators can select or
          place resources.
        </Bullet>
        <Bullet>
          Event maps support zooming, wheel/trackpad zoom, and drag panning.
        </Bullet>
        <Bullet>Clicking a mapped incident opens the incident drawer.</Bullet>
      </Bullets>
      <Screenshot
        url="command-control/CadScreen2.png"
        alt="
        Screen 2 event map showing incident/resource markers, zoom controls, and the resource list."
      ></Screenshot>
    </Section>

    <Section title="Map view selector">
      <Bullets>
        <Bullet>
          Map uses the live geographic map and coordinates from resources,
          vehicles, and incidents.
        </Bullet>
        <Bullet>
          Event uses the uploaded event map and manual or scaled positions.
        </Bullet>
        <Bullet>
          Overlay places a drawn-to-scale event map over the geographic map —
          available once the event map is marked as drawn to scale.
        </Bullet>
        <Bullet>
          GPX shows uploaded GPX course routes on the geographic map with
          kilometre markers.
        </Bullet>
      </Bullets>
    </Section>
  </Page>
)

export default ScreenLayouts
